<script lang="ts">
  import { Line } from 'svelte-chartjs';

  import {
    CategoryScale,
    Chart as ChartJS,
    Colors,
    Filler,
    Legend,
    LineElement,
    LinearScale,
    PointElement,
    Title,
    Tooltip
  } from 'chart.js';

  ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    PointElement,
    Filler,
    CategoryScale,
    Colors
  );

  type LineChartData = {
    activity_date: string;
    views: number;
    learners: number;
  };

  export let data: LineChartData[] = [];
  export let title = 'Title';

  let brandSkyBlue = "#1C9FFE";
  let brandSpaceBlue = "#021B87";

  let defaultDatasetOptions = {
    fill: true,
    borderJoinStyle: 'bevel',
    pointBorderWidth: 10,
    pointHoverRadius: 5,
    pointHoverBorderWidth: 2,
    pointRadius: 1,
    pointHitRadius: 10
  };


  let dates: any[] = [];
  $: {
    // Reset dates when data changes so that old dates aren't still in list
    if (data) {
      dates = [];
    }
  };

</script>

<Line
  data={{
    labels: data.map((row) => {
      // Format month and day in 2 digit format (e.g. the fourth of august -> 08/04)
      let date = new Date(row.activity_date);
      let month = ('0' + (date.getUTCMonth() + 1)).slice(-2);
      let day = ('0' + date.getUTCDate()).slice(-2);
      // Separately store date in locale string for use in tooltips, e.g. the fourth of august -> August 4
      dates.push(new Date(date.setDate(date.getDate() + 1)).toLocaleString('default', { month: 'long', day: 'numeric' }));
      
      return `${month}/${day}`;
    }),
    datasets: [
      {
        label: 'Content Views',
        data: data.map((row) => row.views),
        borderColor: brandSkyBlue,
        pointBackgroundColor: brandSkyBlue,
        backgroundColor: brandSkyBlue + '20',
        ...defaultDatasetOptions
      },
      {
        label: 'Learners',
        data: data.map((row) => row.learners),
        borderColor: brandSpaceBlue,
        pointBackgroundColor: brandSpaceBlue,
        backgroundColor: brandSpaceBlue + '20',
        pointStyle: 'triangle',
        ...defaultDatasetOptions
      }
    ]
  }}
  width={100}
  height={35}
  options={{
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        boxPadding: 4,
        boxWidth: 8,
        boxHeight: 8,
        usePointStyle: true,
        enabled: true,
        intersect: false,
        callbacks: {
          title: function (context) {
            let formattedDate = dates[context[0].dataIndex];
            if (formattedDate.toLowerCase() !== 'invalid date') {
              return formattedDate;
            }
          }
        }
      },
      colors: {
        enabled: false
      },
      title: {
        display: true,
        text: title,
        align: 'start'
      }
    }
  }}
/>